// src/locales/en/stockAdjustment.js
export const stockAdjustment = {
  // Page titles
  createStockAdjustment: 'Create Stock Adjustment',
  editStockAdjustment: 'Edit Stock Adjustment',
  stockAdjustmentDetails: 'Stock Adjustment Details',
  backToStockAdjustments: 'Back to Stock Adjustments',
  allStockAdjustments: 'All Stock Adjustments',
  pageDescription: 'Adjust stock levels for inventory discrepancies',
  detailsPageDescription: 'View and manage stock adjustment details',

  // Form sections
  selectWarehouse: 'Select Warehouse',
  addItems: 'Add Items',
  adjustmentItems: 'Adjustment Items',
  
  // Warehouse selection
  warehouse: 'Warehouse',
  warehouseRequired: 'Warehouse is required',
  selectWarehousePlaceholder: 'Select warehouse',
  allWarehouses: 'All Warehouses',
  
  // Existing adjustments dialog
  existingAdjustments: 'Existing Draft Adjustments',
  existingAdjustmentsMessage: 'You have existing draft adjustments for today. What would you like to do?',
  continueWith: 'Continue with',
  startNewAdjustment: 'Start New Adjustment',
  selectAdjustment: 'Select Adjustment',
  
  // Product search
  searchProducts: 'Search Products',
  searchProductsPlaceholder: 'Search by name, SKU, or barcode...',
  noProductsFound: 'No products found',
  searchingProducts: 'Searching...',
  currentStock: 'Current Stock',
  searchItems: 'Search items...',
  searchPlaceholder: 'Search by adjustment number...',
  
  // Add item form
  addItemTitle: 'Add Item to Adjustment',
  editItemTitle: 'Edit Adjustment Item',
  productName: 'Product',
  recordedCount: 'Recorded Count',
  physicalCount: 'Physical Count',
  physicalCountRequired: 'Physical count is required',
  physicalCountMinimum: 'Physical count must be 0 or greater',
  variance: 'Variance',
  notes: 'Notes',
  notesPlaceholder: 'Add notes for this item...',
  addItem: 'Add Item',
  updateItem: 'Update Item',
  cancel: 'Cancel',
  
  // Items table
  itemNumber: '#',
  itemProduct: 'Product',
  itemRecordedCount: 'Recorded',
  itemPhysicalCount: 'Physical',
  itemVariance: 'Variance',
  itemNotes: 'Notes',
  itemActions: 'Actions',
  edit: 'Edit',
  delete: 'Delete',
  
  // Summary
  totalItems: 'Total Items',
  totalVariance: 'Total Variance',
  noItemsAdded: 'No items added yet',
  addItemsToAdjustment: 'Search and add items to this stock adjustment',
  items: 'items',
  item: 'item',
  ofItems: 'of {{total}} items',
  
  // Actions
  finalizeAdjustment: 'Finalize Adjustment',
  confirmFinalize: 'Finalizing will update stock levels permanently. This action cannot be undone. Are you sure you want to continue?',
  confirmFinalizeTitle: 'Finalize Stock Adjustment',
  confirmDelete: 'Are you sure you want to remove this item?',
  finalize: 'Finalize',
  print: 'Print',
  exportCSV: 'Export CSV',
  
  // Status messages
  adjustmentCreated: 'Stock adjustment {{adjustmentNumber}} created successfully',
  itemAdded: 'Item added to adjustment successfully',
  itemUpdated: 'Item updated successfully',
  itemDeleted: 'Item removed successfully',
  adjustmentFinalized: 'Stock adjustment finalized and stock updated successfully',
  duplicateItem: 'This product has already been added to this adjustment',
  
  // Error messages
  failedToLoadWarehouses: 'Failed to load warehouses',
  failedToLoadAdjustments: 'Failed to load stock adjustments',
  failedToSearchProducts: 'Failed to search products',
  failedToAddItem: 'Failed to add item',
  failedToUpdateItem: 'Failed to update item',
  failedToDeleteItem: 'Failed to delete item',
  failedToFinalize: 'Failed to finalize adjustment',
  noItemsToFinalize: 'Please add at least one item before finalizing',
  failedToLoad: 'Failed to load stock adjustment',
  adjustmentNotFound: 'Stock Adjustment Not Found',
  goBackToList: 'Go Back to List',
  
  // Validation
  pleaseSelectWarehouse: 'Please select a warehouse first',
  atLeastOneItemRequired: 'At least one item is required',
  
  // Loading states
  loadingWarehouses: 'Loading warehouses...',
  loadingAdjustments: 'Loading adjustments...',
  loadingProducts: 'Loading products...',
  addingItem: 'Adding item...',
  updatingItem: 'Updating item...',
  deletingItem: 'Deleting item...',
  finalizing: 'Finalizing adjustment...',
  loadingDetails: 'Loading adjustment details...',
  
  // Adjustment info
  adjustmentNumber: 'Adjustment Number',
  adjustmentDate: 'Adjustment Date',
  createdBy: 'Created By',
  finalizedBy: 'Finalized By',
  status: 'Status',
  statusDraft: 'Draft',
  statusFinalized: 'Finalized',
  allStatuses: 'All Statuses',
  
  // Keyboard shortcuts
  keyboardShortcuts: 'Keyboard Shortcuts',
  focusSearch: 'Focus search',
  clearSearch: 'Clear search',
  submitForm: 'Submit form',
  
  // Variance display
  variancePositive: 'Surplus',
  varianceNegative: 'Shortage',
  varianceZero: 'No Change',
  
  // Common
  sku: 'SKU',
  barcode: 'Barcode',
  quantity: 'Quantity',
  loading: 'Loading...',
  save: 'Save',
  close: 'Close',
  confirm: 'Confirm',
  confirmAction: 'Confirm Finalize',
  yes: 'Yes',
  no: 'No',
  total: 'Total',
  unknownProduct: 'Unknown Product',
  noMatch: 'N/A',
  recorded: 'Recorded',
  physical: 'Physical',
  product: 'Product',
  addedOn: 'Added on',
  tryAdjustingSearch: 'Try adjusting your search criteria',
  dateRange: 'Date Range',
  
  // Empty states
  noAdjustmentsFound: 'No stock adjustments found',
  noAdjustmentsFoundDescription: 'No stock adjustments match your current filters. Try adjusting your search criteria.',
  noAdjustmentsYet: 'No stock adjustments yet',
  noAdjustmentsYetDescription: 'Create your first stock adjustment to track inventory discrepancies.',
  createFirstAdjustment: 'Create First Stock Adjustment',
};